import React from 'react';

function MissingEntriesTooltip() {
  return (
    <div className="messages status missing-entries-tooltip">
      This docket is missing some entries.
        Please review the entire docket below to purchase any missing docket entries of interest.
    </div>
  );
}

export default MissingEntriesTooltip;



// WEBPACK FOOTER //
// ./src/components/case/docket/MissingEntriesTooltip.jsx